import { type JSX } from 'react';

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/home')({
  component: HomeLayout,
});

function HomeLayout(): JSX.Element {
  return <Outlet />;
}
